import { render } from "./AppVersion.vue?vue&type=template&id=a999b466&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=a999b466&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a999b466"]])

export default __exports__